var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form',{staticClass:"paymentWidgets",attrs:{"action":_vm.actionForm,"data-brands":"VISA MASTER AMEX DINERS DISCOVER"}}),_c('div',{staticClass:"d-flex justify-content-between align-items-center p-4"},[_c('LogoComponent',{attrs:{"width":"150"}}),_c('DataFastImageFooter')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }